import { ConfigProvider, Table } from "antd";
import CustomTag from "./Tags/CustomTag";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import { formatNumber } from "src/utils/formatting";


interface MoveGrainStateTableProps{
    binDto: PremierPlusBinDTO | null | undefined;
}

const MoveGrainStateTable : React.FC<MoveGrainStateTableProps> = ({ binDto }) => {

    const getColumns = (): { title: string, dataIndex: string, key: string }[] => {

        const columns = [];

        const augers = binDto?.augers;
        if(augers != null){
            const width = 100 /  ( augers.length + 2) ;

            columns.push( { title: '', dataIndex: 'name', key: 'name', width: width } )
            columns.push({ title: 'Machine', dataIndex: 'machine', key:'machine', width: width });

            columns.push(... augers.map((a) => {
                const numberStr = a.number.toString();
                return { title: numberStr, dataIndex: a.id ?? numberStr, key: a.id ?? numberStr, width: width };
            }));

            return columns;
        }

        return [];
    };

    const getData = () => {
        let data: Array<{ [key: string]: JSX.Element }> = [];

        const augers = binDto?.augers;
        if (augers != null) {
            const machineOn = binDto?.isMachineOn;
            const machineCurrent = binDto?.machineCurrent_mA ? formatNumber(binDto.machineCurrent_mA / 1_000, {decimalPlaces: 2}) : "N/A";

            data = [{
                key: "status",
                unit: "Status",
                name: <p style={{ fontWeight: "bold" }}>Status</p>,
                ...Object.fromEntries([
                    ["machine", <CustomTag icon={machineOn ? <CheckCircleOutlined /> : <CloseCircleOutlined />} color={machineOn ? "green" : "red"} />],
                    ... augers.map((a) => {
                        const numberStr = a.number.toString();
                        const augerOn = a.isOn ?? false;
                        return [a.id ?? numberStr, <CustomTag  icon={augerOn ? <CheckCircleOutlined /> : <CloseCircleOutlined />} color={augerOn ? "green" : "red"} />];
                    })
                   ]
                ),
              },
              {
                key: "current",
                unit: "Amps",
                name: <p style={{ fontWeight: "bold" }}>Current (mA)</p>,
                ...Object.fromEntries([
                    ["machine", <p style={{ fontFamily: 'monospace', fontWeight:'bold'}}>{machineCurrent}</p>],
                    ... augers.map((a) => {
                        const numberStr = a.number.toString();
                        const augerCurrent = a.current_mA ? formatNumber(a.current_mA  / 1_000, {decimalPlaces: 2}) : 'N/A';
                        return [a.id ?? numberStr, <p style={{ fontFamily: 'monospace', fontWeight:'bold'}}>{augerCurrent}</p>];
                        })
                    ]
                ),
              },
            ];
        }
        
        return data;
    };

    return (
        <Table 
        pagination={false} 
        columns={getColumns()} 
        dataSource={getData()} 
        scroll={{ x: 300 }}
        />
    );
};

export default MoveGrainStateTable;
